import { render, staticRenderFns } from "./PropertySearchResultRow.vue?vue&type=template&id=2355134c"
import script from "./PropertySearchResultRow.vue?vue&type=script&lang=js"
export * from "./PropertySearchResultRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports